import { io } from 'socket.io-client';

function normalizeBaseUrl(url) {
  const u = String(url || '').trim();
  if (!u) return '';
  return u.endsWith('/') ? u.slice(0, -1) : u;
}

function getApiBaseUrl() {
  return process.env.REACT_APP_LOCAL_API_URL;
}

let socketSingleton = null;
let currentToken = null;
let currentBaseUrl = null;

export function getSocket() {
  return socketSingleton;
}

export function disconnectSocket() {
  if (socketSingleton) {
    socketSingleton.disconnect();
  }
  socketSingleton = null;
  currentToken = null;
  currentBaseUrl = null;
}

export function connectSocket({ token } = {}) {
  const baseUrl = normalizeBaseUrl(getApiBaseUrl());
  const nextToken = String(token || '').trim();

  if (!baseUrl) {
    throw new Error('API base URL não configurada (REACT_APP_LOCAL_API_URL/REACT_APP_VERCEL_API_URL)');
  }
  if (!nextToken) {
    throw new Error('Token ausente');
  }

  // Reutiliza a instância se já estiver conectada com a mesma configuração
  if (socketSingleton && currentToken === nextToken && currentBaseUrl === baseUrl) {
    if (!socketSingleton.connected) socketSingleton.connect();
    return socketSingleton;
  }

  // Troca de token/base -> recria para evitar estado inconsistente
  disconnectSocket();

  currentToken = nextToken;
  currentBaseUrl = baseUrl;

  socketSingleton = io(baseUrl, {
    auth: { token: nextToken },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 500,
  });

  return socketSingleton;
}




